export default __webpack_public_path__ + "static/media/1100904紫克科技網站_圖形控制面板圖二.6f0fea2d.png";